import { StudyFunctionModel } from './StudyFunctionModel'

export class SaveUserFunctionRequest {
    userId:number
    datasetId:number
    Functions:Array<StudyFunctionModel>
}
